// @ts-ignore
import CanvasJSReact from '@canvasjs/react-charts';
import { useRef, useState } from 'react';
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

type InnerStruct = {
  [key: string]: number;
};

type OuterStruct = {
  [key: string]: InnerStruct;
}

function summarize(o : OuterStruct) : InnerStruct {
  const ret : InnerStruct = {};
  for (const key in o) {
    let agg = 0;
    for (const iKey in o[key]) {
      agg += o[key][iKey];
    }
    ret[key] = agg;
  }
  return ret;
}

function innerStructToLabeledData(i : InnerStruct) : {y : number, label : string}[] {
  const ret : {y : number, label : string}[] = [];

  for (const key in i) {
    ret.push({y: i[key], label: key});
  }

  return ret;
}

type Props = {
  values: OuterStruct;
  title : string;
  style? : React.CSSProperties;
}

export type ValueType = OuterStruct;

export default function HierarchicPieChart({values, title, style} : Props) {
  const chartRef = useRef<any>(undefined);
  const [displayedValue, setDisplayedValue] = useState<InnerStruct | undefined>(undefined);

  function chartDrilldownHandler(e : any) {
    if (displayedValue === undefined) {
      const dataPoint : {y : number, label : string} = e.dataPoint;
      const chart = chartRef.current;
      console.log(e);
      chart.options.title = { text: "DrilledDown"}
      setDisplayedValue(values[dataPoint.label]);
    }
  }

  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light1", // "light1", "dark1", "dark2"
    title: {
      text: `Tag distributions in ${title}`
    },
    data: [{
      click: (e : any) => chartDrilldownHandler(e),
      type: "pie",
      cursor: "pointer",
      indexLabel: "{label}: {y} pcs",
      startAngle: -90,
      dataPoints: innerStructToLabeledData(displayedValue ?? summarize(values)) 
    }]
  }

  const buttonStyle : React.CSSProperties={
    borderRadius: '4px',
    padding: '8px',
    border: 'none',
    fontSize: '16px',
    backgroundColor: '#2eacd1',
    color: 'white',
    cursor: 'pointer',
    width: "100%",
    visibility: (displayedValue)?"visible":"hidden",
  }

  return <span style={style}>
    <CanvasJSChart options={options} onRef={(ref : any) => chartRef.current = ref}/>
    <button 
      id="backButton" 
      onClick={() => {
        console.log("setDisplayedValue(undefined)")
        setDisplayedValue(undefined)
      }}
      style={buttonStyle}
    >&lt; Back</button>
  </span>
}